import AccordionInfo from './AccordionInfo';

export default AccordionInfo;
